import React from 'react';
import {useTranslation} from 'react-i18next';

/* Quanto si deve scendere, in schermate, prima che la freccia compaia. */
const SOGLIA = 1;

/**
 * LA FRECCIA PER TORNARE SU (modulo Piè di pagina › Freccia per tornare su,
 * accesa di serie): il tasto tondo in basso a destra che riporta in cima.
 *
 * Compare solo dopo che si e' scesi di una schermata: in cima non serve, e
 * cosi' non copre mai il tasto dell'audio del video in Home, che sta nella
 * vetrina in alto. Sul telefono sta sopra la barra in basso; si nasconde
 * quando c'e' un pannello aperto (`nascosta`), e il cassetto dei Fornitori
 * e la schedina le stanno sopra (Nova.css). Chi ha chiesto meno animazioni
 * torna su di colpo.
 */
export default function RisaliNova({nascosta}) {
  const {t} = useTranslation();
  const [scesa, setScesa] = React.useState(false);

  React.useEffect(() => {
    let attesa = 0;
    const guarda = () => {
      attesa = 0;
      setScesa(window.scrollY > window.innerHeight * SOGLIA);
    };
    const allo = () => { if (!attesa) attesa = window.requestAnimationFrame(guarda); };
    guarda();
    window.addEventListener('scroll', allo, {passive: true});
    window.addEventListener('resize', allo);
    return () => {
      window.removeEventListener('scroll', allo);
      window.removeEventListener('resize', allo);
      if (attesa) window.cancelAnimationFrame(attesa);
    };
  }, []);

  if (!scesa || nascosta) return null;
  const risali = () => {
    const piano = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({top: 0, behavior: piano ? 'auto' : 'smooth'});
  };
  return (
    <button type={'button'} className={'nova-risali'} onClick={risali} aria-label={t('Torna su')} title={t('Torna su')}>
      <svg width={'20'} height={'20'} viewBox={'0 0 24 24'} fill={'none'} stroke={'currentColor'}
        strokeWidth={'2.4'} strokeLinecap={'round'} strokeLinejoin={'round'} aria-hidden={'true'}>
        <path d={'M12 19V5M5 12l7-7 7 7'}/>
      </svg>
    </button>
  );
}
